<script lang="ts" setup>
import { CtToast } from '@camelot/components'
import { storeToRefs } from 'pinia'
import BookingFooter from '~/components/footer/BookingFooter.vue'
import BookingNav from '~/components/header/BookingNav.vue'
import BottomSheetContainer from '~/components/sidebar/mobile/BottomSheetContainer.vue'
import SidebarSumm from '~/components/sidebar/SidebarSumm.vue'
import { useOfferStore } from '~/stores/offer'
import { usePrebookingCreationStore } from '~/stores/prebooking-creation'
import { useStepStore } from '~/stores/step'

const offerStore = useOfferStore()
const stepStore = useStepStore()
const prebookingCreationStore = usePrebookingCreationStore()

const logoF2mAndSN = `${useRuntimeConfig().public.imageURL}/logo/free2move-logo.svg`

const { errorPrebookingCreation } = storeToRefs(prebookingCreationStore)

const showSideBarSummaryBox = computed<boolean>(() => {
  return !!offerStore.selectedOffer && stepStore.currentStepPath !== 'category'
})

const showBottomSheetSummary = computed<boolean>(() => {
  return !!offerStore.selectedOffer && stepStore.currentStepPath !== 'category'
})
</script>

<template>
  <section class="min-h-screen flex flex-col">
    <header
      class="flex items-center justify-center md:justify-start
             md:sticky  top-0 z-10 h-60  md:h-[80px]
             bg-white shadow-4"
    >
      <div class="md:container md:mx-auto ">
        <img class="h-40" :src="logoF2mAndSN" data-testid="logo" alt="Free to move logo">
      </div>
    </header>

    <CtToast v-if="errorPrebookingCreation" variant="error" :text="errorPrebookingCreation ?? 'Oops 🤷🏻'" @close="prebookingCreationStore.clearErrorToast()" />

    <main class="grow shrink-0 mx-auto md:container">
      <BookingNav class="my-[18px] md:my-32 xs:ml-16 md:ml-16 xl:ml-8" />

      <section class="flex">
        <div class="xs:max-xl:px-16 xs:max-md:pb-32">
          <slot />
        </div>

        <SidebarSumm v-if="showSideBarSummaryBox" class="max-md:hidden md:visible md:max-w-[335px] lg:max-w-[335px] grow" />
      </section>
    </main>
    <BookingFooter class="flex-none xs:mb-2" />
    <BottomSheetContainer v-if="showBottomSheetSummary" class="md:hidden" />
  </section>
</template>

<style scoped lang="scss">
:deep(.ct-toast) {
  position: relative;
  font-size: 1em;
}
</style>
